import { translate } from '@jsverse/transloco';
export enum ReportType {
    VULNERABILITY = 'VULNERABILITY',
    PCI_PEN_TEST = 'PCI_PEN_TEST',
}

export class ReportTypeHelper {
    static getReportTypeString(type: ReportType): string {
        switch (type) {
            case ReportType.VULNERABILITY:
                return translate('CORE.REPORT_TYPES.VULNERABILITY');
            case ReportType.PCI_PEN_TEST:
                return translate('CORE.REPORT_TYPES.PCI_PEN_TEST');
            default:
                return type;
        }
    }
}
